import { utilsApis } from '@apis/utilsApis';
import { useQuery } from '@hooks/useQuery';

export const useGenerateStatusError = (status: number) => {
  return useQuery([`/generate-error/${status}/`], () =>
    utilsApis.get('/generate-error/{status}/', { path: { status } }).then((r) => r['200']!),
  );
};

export const useGenerateTypeError = () => {
  return useQuery(['/generate-error/200/'], () =>
    utilsApis.get('/generate-error/200/', {}).then((r) => r['200']!),
  );
};
